import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const GetBillOfMaterialDetail = (params: any) =>
  GET_ENC(API_ENDPOINTS.BILL_OF_MATERIAL.GET_DETAIL + params, null);

export const GetBillOfMaterialList = (params: any) =>
  GET_ENC(API_ENDPOINTS.BILL_OF_MATERIAL.LIST + params, null);

export const CreateBillOfMaterial = (data: any) =>
  POST_ENC(API_ENDPOINTS.BILL_OF_MATERIAL.CREATE, data);

export const UpdateBillOfMaterial = (data: any) =>
  POST_ENC(API_ENDPOINTS.BILL_OF_MATERIAL.UPDATE, data);

export const DeleteBillOfMaterial = (data: any) =>
  POST_ENC(API_ENDPOINTS.BILL_OF_MATERIAL.DELETE, data);

export const GetBillOfMaterialDetailBOM = (params: any) =>
  GET_ENC(API_ENDPOINTS.BILL_OF_MATERIAL.GET_DETAIL_BOM + params, null);

export const GetPossibleBOMCountByAvailableStock = (params: any) =>
  GET_ENC(API_ENDPOINTS.BILL_OF_MATERIAL.POSSIBLE_BOM_COUNT_BY_AVAILABLE_STOCK + params, null);